import { SapReservations } from "../../features"

const SapReservationsPage = () => {
  return <SapReservations />
}

export default SapReservationsPage
